import { useState, useRef, useEffect } from 'react'
import moment from 'moment'
import { Chip, Container, TypoGraph, Tabs } from 'components'
import { reportingTabs } from 'constants/status'
import styles from './reporting.module.scss'
import {
  InsuranceHeartbeatReport,
  MileageReportingDashboard,
  LocationReportingDashboard,
  PortfolioDashboard,
  RiskDecileDashboard,
} from './partial'
import strings from 'strings'

interface IReportingProps {}

const Reporting: React.FC<IReportingProps> = (props) => {
  const [reportingTab, setReportingTab] = useState(0)
  const [updateDate, setUpdateDate] = useState<any>()

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      window.scrollTo(0, 0)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const TabPanel = (props: { print: boolean }) => {
    const { print } = props
    switch (reportingTab) {
      case 0:
        return (
          <MileageReportingDashboard
            print={print}
            useCarrierFilters={false}
          />
        )
      case 1:
        return ( 
          <LocationReportingDashboard
            print={print}
            useCarrierFilters={false}
          />
        )
      case 2:
        return (
          <InsuranceHeartbeatReport
            print={print}
            useCarrierFilters={false}
          />
        )
      case 3:
        return <PortfolioDashboard />
      case 4:
        return <RiskDecileDashboard useCarrierFilters={false} />
      default:
        return <></>
    }
  }

  const getPageMargins = () => {
    return `@page { margin: 30px!important; }`
  }

  return (
    <Container>
      <div className={styles.pageHeader} data-testid="portfolio-reporting-header">
        <div className={styles.pageTitle}>
          <span className={styles.pageTitleAccent} />
          <TypoGraph variant="h3" mb={0} content={strings.PORTFOLIO_REPORTING.PAGE_TITLE} dataTestId="portfolio-reporting-title" />
        </div>
        <div className={styles.pageTitleDivider} />
        <Tabs
          tabData={reportingTabs}
          value={reportingTab}
          id={reportingTabs[reportingTab].label}
          handleChange={(_e, val) => setReportingTab(val)}
          sxContainer={{ flex: 1, marginBottom: '-1px' }}
        />
        {updateDate && (
          <Chip
            label={`Updated ${moment(updateDate).format('dddd, MMMM Do')}`}
            variant="filled"
            sx={{
              backgroundColor: '#E1FAEB',
              color: '#20693D',
              alignSelf: 'center',
              mr: '1rem',
              flexShrink: 0,
            }}
          />
        )}
      </div>
      <Container>
        <TabPanel print={false} />
      </Container>
      <style>{getPageMargins()}</style>
      <div style={{ visibility: 'hidden' }}>
        <div style={{ display: 'flex', width: '100%' }}>
          <div ref={ref} style={{ width: '65rem' }}>
            <TabPanel print={true} />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Reporting
